<template>
  <div class="result" @scroll="onScroll">
    <HeadTitle
      :title="headTitle"
      :is-gradient="resultSubPath === 'finished'"
      :gradient="titleOpacity"
      @back="onBack"
    />
    <!--OrderStatusRouteOutlet-->
    <div class="resultTop">
      <router-view :meal-code="tableOrSerial" :detail="orderDetail" />
    </div>

<!--    <Banner-->
<!--      v-if="bannerList.list && bannerList.list.length > 0 && orderDetail && orderDetail.statusId !== 'ORDER_CANCELLED'"-->
<!--      class="banner-container"-->
<!--      :list="bannerList.list"-->
<!--      :ratio="bannerList.ratio"-->
<!--      />-->

    <div class="resultBottom font-size-12" :class="{ finished: isFinished }">
      <!--DELIVERY模式下店铺信息-->
      <div v-if="delivery" class="q-pa-md row items-start q-gutter-md">
        <q-card flat bordered class="my-card from-box">
          <q-card-section>
            <div class="from-div">
              <span>{{ $t('result.from') }}</span>
              <span>
                <a :href="`tel:${storeInfra.phone}`">
                  <span class="iconfont">&#xe743;</span>&nbsp;&nbsp;
                  {{ $t('result.connectStore') }}
                </a>
              </span>
            </div>
          </q-card-section>
          <q-separator inset />
          <q-card-section>
            <q-img src="~assets/images/Union.png" class="Street" />
            <span class="StreetBoba">{{ storeInfra.name }}</span>
          </q-card-section>
          <q-card-section class="tempor-div">
            <span class="icon-googlemap iconfont">&#xe614;</span>
            <div class="tempor">
              <div v-if="storeAddress.main" class="tempor1">
                {{ storeAddress.main }}
              </div>
              <div v-if="storeAddress.second" class="tempor1">
                {{ storeAddress.second }}
              </div>
            </div>
          </q-card-section>
          <template v-if="orderDetail && orderDetail.scheduled">
            <q-separator inset />
            <q-card-section class="q-px-lg">
              <div class="q-px-sm">
                <div class="StreetBoba">{{ $t('result.timeDelivery') }}</div>
                <div class="text-theme-gray">
                  {{ scheduled.start }}-{{ scheduled.end }}
                </div>
              </div>
            </q-card-section>
          </template>
        </q-card>
      </div>
      <!--DELIVERY模式下骑手信息-->
      <q-card
        v-if="delivery && riderInfo.driverName"
        flat
        bordered
        class="my-card Delivery-box"
      >
        <q-card-section>
          <div class="Delivery-div">
            <span>{{ $t('result.transport') }}</span>
            <span>
              <i class="section-span-icon iconfont dm-phone" />
              <a :href="`tel:${riderInfo.phone}`">
                {{ $t('result.connectDeliver') }}
              </a>
            </span>
          </div>
        </q-card-section>
        <q-separator inset />
        <q-card-section>
          <div class="gosend-div">
            <span>{{ $t('result.deliver') }}</span>
            <span>{{ riderInfo.courierName }}</span>
          </div>
          <div class="gosend-div">
            <span>{{ $t('result.driver') }}</span>
            <span>{{ riderInfo.driverName }}</span>
          </div>
          <div class="gosend-div">
            <span>{{ $t('result.expressInformation') }}</span>
            <span>{{ riderInfo.courierId }}</span>
          </div>
          <div class="Live-box">
            <a :href="riderInfo.trackingUrl" class="Live-span" target="_blank">
              {{ $t('result.track') }}
            </a>
            <i class="iconfont dm-right" />
          </div>
        </q-card-section>
      </q-card>

      <!--Receipt-->
      <Receipt class="result-rec" />

      <!--DELIVERY模式下的更多信息-->
      <div
        v-if="isSuccessDELIVERY"
        class="q-pa-md row items-start q-gutt-md Other-box-box"
      >
        <q-card flat bordered class="my-card Other-box">
          <q-card-section>
            <div class="Other-div">
              <span>{{ $t('result.moreDetails') }}</span>
            </div>
          </q-card-section>
          <q-separator inset />
          <q-card-section>
            <div class="gosend-div">
              <span>{{ $t('result.orderId') }}</span>
              <span>{{ moreDetail.orderId }}</span>
            </div>
            <div class="gosend-div">
              <span>{{ $t('result.orderTime') }}</span>
              <span>{{ moreDetail.orderTime }}</span>
            </div>
            <div class="gosend-div">
              <span>{{ $t('result.paymentType') }}</span>
              <span>{{ moreDetail.paymentName }}</span>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <!--底部按钮-->
      <div class="row q-gutter-x-md q-mt-md">
        <div class="col">
          <q-btn
            no-caps
            class="full-width goHomeBtn bg-white border-radius-8"
            :class="
              serviceTypeStatus === 'DELIVERY' ? 'goHomeBtns' : 'goHomeBtn'
            "
            outline
            color="grey-4"
            unelevated
            @click.native="goProductsList"
          >
            <span class="text-black">{{ $t('result.goHome') }}</span>
          </q-btn>
        </div>
        <div
          v-if="
            (app.resultSubPath === 'finished' ||
              app.resultSubPath === 'completed') &&
            reviewUrl
          "
          class="col"
        >
          <q-btn
            no-caps
            unelevated
            :href="reviewUrl"
            target="_blank"
            color="primary"
            class="full-width border-radius-8"
          >
            <span class="flex">
              <i class="iconfont dm-a-Pencilalt" />
              <span class="q-ml-sm">Add Review</span>
            </span>
          </q-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import orderMixins from 'pages/mixin/orderMixins.js';
// eslint-disable-next-line import/order
import { createMeta } from './meta.js';
import MButton from 'src/components/MButton';


export default {
  mixins: [orderMixins],
  meta() {
    return createMeta(this);
  },
};
</script>
<script setup>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  provide,
  defineExpose,
} from 'vue';
import { getOrderInfo, checkoutStatus } from 'src/api/order.js';
import Banner from 'src/pages/list/components/Banner.vue'
import { GROUP_TYPE } from '../../utils/config';
import { formatDate } from '../../utils/base';
import HeadTitle from './components/HeadTitle.vue';
import Receipt from '../full_dine_in/components/Receipt.vue';
import { use18n, useIns, useStore } from '../../utils/v2_helper/common.js';
import { useRoute, useRouter } from '../../utils/v2_helper/router/globals.js';

// TODO: Product List 展示更多没实现
const app = useIns();
const route = useRoute();
const router = useRouter();
const store = useStore();
const { $t } = use18n();


const orderDetail = ref();
// head 是否显示
const titleOpacity = ref(0);
let timer = false;

// 评论地址
const horegoReviewUrl = ref('');
const reviewUrl = computed(() => {
  if (horegoReviewUrl.value) {
    if (/^https?:\/\//.test(horegoReviewUrl.value)) {
      return horegoReviewUrl.value;
    }
    return 'https://dashboard.bakmigm.co.id/';
  }
  return false;
});

const bannerList = computed(() => ({
    list: [
//      {
//        imgSrc: 'https://static.bakmigm.co.id/menu-buyer/order/horego-travel-prize.png',
//        link: 'https://horego.onelink.me/BDBE/f2375wjf'
//      },
//       {
//         imgSrc: 'https://static.bakmigm.co.id/menu-buyer/order/horego-travel2-prize.jpg',
//         link: 'https://horego.onelink.me/BDBE/rwxws2uc'
//       },
    ],
    ratio: 1
  }))

// 订单服务类型
const serviceType = computed(() => orderDetail.value?.serviceType || '');
// 显示的桌号还是序列
const tableOrSerial = computed(() => {
  const { serialNumber, tableNumber } = orderDetail.value || {};
  const MAP = {
    DINE_IN: tableNumber,
    PICK_UP: serialNumber,
  };
  return MAP[serviceType.value];
});
const delivery = computed(() => orderDetail.value?.serviceType === 'DELIVERY');
const headTitle = computed(() => {
  const payment = orderDetail.value?.payments?.[0]?.paymentMethodTypeId;
  const m = {
    ORDER_APPROVED:
      payment === 'CASH'
        ? $t('result.successCashTitle')
        : $t('result.successDineInTitle2'),
    ORDER_PROCESSING: $t('result.preparing'),
    ORDER_SHIPPING: $t('result.finishedTitle'),
    ORDER_COMPLETED:
      orderDetail.value?.serviceType === 'DINE_IN'
        ? $t('result.completedTitle1')
        : $t('result.completedTitle2'),
    ORDER_CANCELLED: $t('result.cancel.refundTitle')
  };
  if (delivery.value) return app.orderMsgs.status;
  return m[orderDetail.value?.statusId];
});
const isFinished = computed(() => route.path.indexOf('/result/finished') > -1);
// 店铺信息（delivery）
const storeInfra = computed(() => ({
  phone: orderDetail.value?.seller?.address?.phone,
  name: orderDetail.value?.productStoreName,
}));
// 店铺地址（delivery）
const storeAddress = computed(() => ({
  main: orderDetail.value?.seller?.address?.address3,
  second: orderDetail.value?.seller?.address?.address1,
}));
// 骑手信息（delivery）
const riderInfo = computed(() => ({
  phone: orderDetail.value?.shipment.driverPhone,
  courierName: orderDetail.value?.shipment.name,
  courierId: orderDetail.value?.shipment.externalId,
  driverName: orderDetail.value?.shipment.driverName,
  trackingCode: orderDetail.value?.shipment.trackingStatusCode, // 状态码
  trackingUrl: orderDetail.value?.shipment?.liveTrackingUrl,
}));
// 订单id
const orderId = computed(() => {
  const { orderId, order_id: id } = route.query;
  return (orderId || id || '').replace(/\d+_DM/, '');
});
// 更多信息（delivery）
const moreDetail = computed(() => {
  const payment = orderDetail.value?.payments?.[0];
  const paymentName = `${
    payment?.paymentDisplayName?.replace('(Online)', '') || ''
  } ${payment?.type === 'bank-transfer' ? $t('checkout.virtualAccount') : ''}`;
  return {
    orderId: orderId.value,
    orderTime: formatDate(
      new Date(orderDetail.value.createdTime.dbStamp),
      'E, MMMM yyyy HH:mm',
      app.language,
    ),
    paymentName,
  };
});
// 预订单时间
const scheduled = computed(() => {
  const start = formatDate(
    orderDetail.value?.scheduledDate?.dbStamp,
    'EEE, dd MMMM, HH:mm',
  );
  const end = formatDate(orderDetail.value?.scheduledEndDate?.dbStamp, 'HH:mm');
  return {
    start,
    end,
  };
});

// =====funcs====
function goProductsList() {
  window.location.href = `/${app.storeUrl}/products-list`;
}
function goBack() {
  window.history.pushState(null, null, document.URL);
}
function onBack() {
  if (app.logged) {
    router.replace(`/${app.storeUrl}/user/order-history`);
  } else {
    window.location.href = `/${app.storeUrl}/products-list`;
  }
}

function isPkg(type) {
  return type === GROUP_TYPE.PACKAGE;
}
function onScroll(e) {
  titleOpacity.value = e.target.scrollTop / 200;
}
function checkFullDineInOrder() {
  return orderDetail.value.serviceType === 'FULL_DINE_IN';
}

async function getOrder() {
  try {
    const payPrefId =
      orderDetail.value?.payments?.[0]?.orderPaymentPreferenceId;
    const oid = payPrefId ? `${payPrefId}_DM${orderId.value}` : orderId.value;
    const call = orderDetail.value ? checkoutStatus : getOrderInfo;
    const res = await call({ orderId: oid });
    if (!timer) return;
    const { code, data } = res;
    if (code === 200) {
      app.$q.loading.hide();
      horegoReviewUrl.value = data.reviewUrl;

      orderDetail.value = {
        ...(orderDetail.value || {}),
        ...data.orderDetail,
      };
      // full dine in order check
      const isFull = checkFullDineInOrder();
      if (isFull) {
        router.replace({
          name: 'FullPaySuccess',
          query: { orderId: orderId.value },
        });
        return;
      }

      const jumpAddress = app.resultSubPath;
      if (route.path.indexOf('products-list') > -1) {
        return;
      }
      if (jumpAddress === 'waiting') {
        if (app.isShopeePay) {
          router.push({
            path: `/${app.storeUrl}/shopee-waiting`,
            query: { orderId: orderDetail.value?.orderId },
          });
          return;
        }
        if (app.isOVO) {
          router.push({
            path: `/${app.storeUrl}/ovo-waiting`,
            query: { orderId: orderDetail.value?.orderId },
          });
          return;
        }
        if (app.isGoPay) {
          router.push({
            path: `/${app.storeUrl}/gopay-waiting`,
            query: { orderId: orderDetail.value?.orderId },
          });
          return;
        }
        if (app.isDana) {
          router.push({
            path: `/${app.storeUrl}/dana-waiting`,
            query: { orderId: orderDetail.value?.orderId },
          });
          return;
        }
      }
      const path = `/${app.storeUrl}/result/${jumpAddress}`;
//      const path = `/${app.storeUrl}/result/canceled`;
      if (path !== route.path) {
        router.push({ path, query: { orderId: app.orderId } });
      }
      if (jumpAddress === 'completed') return;
      if (jumpAddress === 'canceled') return;
    }
    timer = setTimeout(getOrder, 3000);
  } catch (error) {
    timer = setTimeout(getOrder, 3000);
  }
}

function initOrderId() {
  // eslint-disable-next-line camelcase
  const { orderId, order_id } = route.query;
  // eslint-disable-next-line camelcase
  store.dispatch('Menu/setOrderId', orderId || order_id);
}
function initPool() {
  app.$q.loading.show({ delay: 400 });
  timer = setTimeout(getOrder, 400);
}
onMounted(() => {
  initOrderId();
  initPool();
});
onBeforeUnmount(() => {
  clearTimeout(timer);
  timer = null;
});

provide(
  'orderData',
  computed(() => ({ orderDetail: orderDetail.value })),
);

provide(
  'updateOrderData', getOrder);
provide('hide_timeline', true);

// provide for mixins
const paymentMethodTypeId = computed(
  () => orderDetail.value?.payments?.[0]?.paymentMethodTypeId,
);
const shipmentStatusCode = computed(() => riderInfo.value.trackingCode);
const serviceTypeStatus = computed(() => serviceType.value);
defineExpose({
  shipmentStatusCode,
  serviceTypeStatus,
  paymentMethodTypeId,
});
</script>

<style lang="scss" scoped>
.break-word {
  word-break: break-word;
}
.disabled {
  display: none;
}
.worktext {
  word-wrap: break-word;
}
.result {
  height: 100%;
  overflow-y: auto;
  :deep(.result-rec) {
    margin: 0;
  }
  .resultTop {
    // height: 62.5%;
    .resultStatus {
      padding-bottom: 200px;
    }
    :deep(.resultStatus) {
      background-position: 0 0;
      .title {
        margin-top: 125px;
      }
    }
  }
  .resultBottom {
    // min-height: 37.5%;
    padding: 0 24px 48px;
    background: #ffffff;
    .bottomBoxBox {
      background: #f3f4f6;
      padding: 32px;
      margin-top: -30px;
    }
    .bottomBox {
      background: #f3f4f6;
      padding: 32px;
    }
    .goHomeBtn {
      // border: 1px solid #d1d5db;
      :deep(.q-btn__wrapper) {
        // padding: 12px 0;
      }
    }
    &.finished {
      background: #ffffff;
      .goHomeBtns {
        // margin-top: -3px;
      }
    }
  }

  .banner-container {
    padding: 0 24px 12px;
  }
}
.my-card {
  width: 100%;
  // background: #F3F4F6;
  border-radius: 8px;
  .q-separator--horizontal {
    background: #e5e7eb;
    margin: 0 30px;
  }
  background: #f3f4f6;
}

.q-gutter-md > * {
  margin-top: 0;
  margin-bottom: 0;
}
// from 卡片样式
.from-box {
  background: #fff;
}

.Delivery-box {
  background: #fff;
}
.from-div {
  margin: 0 18px 0 18px;
  height: 20px;
  display: flex;
  justify-content: space-between;
  & > span:nth-child(1) {
    font-size: 16px;
    font-weight: bold;
  }
  & > span:nth-child(2) {
    font-size: 12px;
    font-weight: 800;
    color: $primary;
    & > span {
      padding-left: 5px;
    }
  }
}
.Resi-box {
  margin-top: -10px;
  background: #ffffff;
  padding: 32px;
  border: 1px solid #e5e7eb;
}
.my-card {
  width: 100%;
  // background: #F3F4F6;
  border-radius: 8px;
  .q-separator--horizontal {
    background: #e5e7eb;
    margin: 0 30px;
  }
  background: #f3f4f6;
}

// from 卡片样式
.from-box {
  background: #fff;
}

.Delivery-box {
  background: #fff;
}
.from-div {
  margin: 14px 18px 0 18px;
  height: 20px;
  display: flex;
  justify-content: space-between;
  & > span:nth-child(1) {
    font-size: 16px;
    font-weight: bold;
  }
  & > span:nth-child(2) {
    font-size: 12px;
    font-weight: 800;
    color: $primary;
    & > span {
      padding-left: 5px;
    }
  }
}
.Street {
  width: 16px;
  height: 16px;
  margin: -2px 10px 0 16px;
}
.StreetBoba {
  font-size: 16px;
  font-weight: bold;
}
.icon-googlemap {
  width: 20px;
  height: 20px;
  padding-right: 10px;
  // color: $primary;
}
.tempor-div {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin: -16px 10px 0 16px;
}
.tempor {
  color: $black;
  font-weight: 600;
  padding-bottom: 10px;
  width: calc(100% - 20px);
  .tempor1 {
    padding-bottom: 5px;
  }
}

// 电话图标
.section-span-icon {
  width: 20px;
  height: 20px;
  color: $primary;
}
.Delivery-div {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin: 10px 18px 0 18px;
  & > span:nth-child(2) {
    color: $primary;
    & > span {
      padding-left: 5px;
      font-size: 12px;
    }
  }
}
.gosend-div {
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  margin: 0 18px 0 20px;
  // 间隔线
  & > span:nth-child(1) {
    color: #6b7280;
  }
  & > span:nth-child(2) {
    color: $black;
  }
}
.Live-box {
  text-align: center;
  margin: 0 18px 0 18px;
  .Live-span {
    font-size: 12px;
    font-weight: bold;
    color: $primary;
    text-align: center;
  }
  .iconfont {
    color: $primary;
  }
}

.Other-box {
  margin-top: -2px;
  background: #ffffff;
}
.Other-div {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin: 14px 18px 0 18px;
  & > span:nth-child(2) {
    color: $primary;
    & > span {
      padding-left: 5px;
      font-size: 12px;
    }
  }
}
.gosend-div {
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  margin: 0 18px 0 20px;
  // 间隔线
  & > span:nth-child(1) {
    color: #6b7280;
  }
  & > span:nth-child(2) {
    color: $black;
  }
}
.Live-box {
  text-align: center;
  margin: 0 18px 0 18px;
  .Live-span {
    font-size: 12px;
    font-weight: bold;
    color: $primary;
    text-align: center;
  }
}
.q-pa-md {
  padding: 16px 0;
  // margin-top: 10px;
}
//点击 展示 更多
.Show-more {
  color: $primary;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  .Rectangle-icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-top: -2px;
  }
  .iconfont {
    vertical-align: middle;
  }
}
// 收起 展示
.Show-less {
  color: $primary;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  .Rectangle-icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-top: -2px;
  }
}
.Receipt {
  // margin-top: 10px;
  font-weight: bold;
  color: $black;
  padding-bottom: 5px;
}

// 费用style
.fee-item {
  &.promo {
    color: $primary;
  }
  &-key {
    flex: 1;
    padding-right: 20px;
  }
}
.free-prod {
  padding-left: 0;
  padding-right: 0;
}
</style>

<style lang="scss" scoped>
.apart-area-address {
  font-size: 16px;
  color: #6b7280;
  font-weight: normal !important;
}

/** ====== */
.product {
  &-count {
    width: 30px;
    flex: auto;
    width: 20px;
    height: 20px;
    outline: 2px solid #e5e7eb;
    text-align: center;
    line-height: 20px;
    color: $grayFont;
    border-radius: 4px;
    font-weight: bold;
  }
}
</style>
